export default "__VITE_ASSET__bff45de2__"